var _defs, _mask, _mask2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "384.5px",
    height: "501.5px",
    viewBox: "0 0 384.5 501.5",
    enableBackground: "new 0 0 384.5 501.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "bg-grope",
    mask: "url(#mask-rbz-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-221.000000, -144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "211.8,233.4 220.8,249 202.7,249                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "229.6,253.8 194,253.8 211.8,222.9                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "238.3,259.5 185.2,259.5 211.8,213.5                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "247.1,264.2 176.5,264.2 211.8,203.1                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "255.8,269 167.7,269 211.8,192.7                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "264.6,274.7 159,274.7 211.8,183.2                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "273.3,279.5 150.2,279.5 211.8,172.8                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "282.1,284.2 141.5,284.2 211.8,162.4                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "290.8,289.9 132.8,289.9 211.8,152.9                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "299.5,294.7 124,294.7 211.8,142.5                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "308.3,299.4 115.3,299.4 211.8,132.1                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "317,305.1 106.5,305.1 211.8,122.7                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "325.8,309.9 97.8,309.9 211.8,112.2                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "334.5,314.6 89,314.6 211.8,101.8                     "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "343.3,320.3 80.3,320.3 211.8,92.4                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "352,325.1 71.5,325.1 211.8,82                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "360.8,329.8 62.8,329.8 211.8,71.6                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "369.5,334.6 54,334.6 211.8,61.2                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "378.3,340.3 45.3,340.3 211.8,51.7                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "387,345 36.5,345 211.8,41.3                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "395.8,349.8 27.8,349.8 211.8,30.9                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "211.8,21.4 404.5,355.5 19.1,355.5                    "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape_1_",
    transform: "translate(385.525215, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "211.7,233.4 220.7,249 202.6,249                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "229.5,253.8 193.9,253.8 211.7,222.9                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "238.2,259.5 185.1,259.5 211.7,213.5                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "246.9,264.2 176.4,264.2 211.7,203.1                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "255.7,269 167.6,269 211.7,192.7                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "264.4,274.7 158.9,274.7 211.7,183.2                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "273.2,279.5 150.1,279.5 211.7,172.8                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "281.9,284.2 141.4,284.2 211.7,162.4                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "290.7,289.9 132.6,289.9 211.7,152.9                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "299.4,294.7 123.9,294.7 211.7,142.5                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "308.2,299.4 115.1,299.4 211.7,132.1                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "316.9,305.1 106.4,305.1 211.7,122.7                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "325.7,309.9 97.7,309.9 211.7,112.2                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "334.4,314.6 88.9,314.6 211.7,101.8                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "343.2,320.3 80.2,320.3 211.7,92.4                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "351.9,325.1 71.4,325.1 211.7,82                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "360.6,329.8 62.7,329.8 211.7,71.6                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "369.4,334.6 53.9,334.6 211.7,61.2                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "378.1,340.3 45.2,340.3 211.7,51.7                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "386.9,345 36.4,345 211.7,41.3                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "395.6,349.8 27.7,349.8 211.7,30.9                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "211.7,21.4 404.4,355.5 18.9,355.5                    "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape_2_",
    transform: "translate(192.762608, 333.549716)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "211.6,234.3 220.6,250 202.5,250                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "229.4,254.7 193.8,254.7 211.6,223.9                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "238.1,259.5 185,259.5 211.6,213.5                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "246.9,265.2 176.3,265.2 211.6,204                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "255.6,269.9 167.5,269.9 211.6,193.6                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "264.3,274.7 158.8,274.7 211.6,183.2                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "273.1,280.4 150,280.4 211.6,173.8                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "281.8,285.2 141.3,285.2 211.6,163.3                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "290.6,289.9 132.5,289.9 211.6,152.9                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "299.3,295.6 123.8,295.6 211.6,143.5                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "308.1,300.4 115,300.4 211.6,133.1                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "316.8,305.1 106.3,305.1 211.6,122.7                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "325.6,310.8 97.6,310.8 211.6,113.2                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "334.3,315.6 88.8,315.6 211.6,102.8                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "343.1,320.3 80.1,320.3 211.6,92.4                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "351.8,326 71.3,326 211.6,82.9                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "360.6,330.8 62.6,330.8 211.6,72.5                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "369.3,335.5 53.8,335.5 211.6,62.1                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "378,341.2 45.1,341.2 211.6,52.6                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "386.8,346 36.3,346 211.6,42.2                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "395.5,350.7 27.6,350.7 211.6,31.8                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "211.6,21.4 404.3,355.5 18.8,355.5                    "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Shape_3_",
    transform: "translate(0.000000, 348.650000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "229.8,121.7 194.2,121.7 212,152.5                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "238.6,116.9 185.5,116.9 212,162.9                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "247.3,111.2 176.7,111.2 212,172.4                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "256.1,106.5 168,106.5 212,182.8                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "264.8,101.7 159.3,101.7 212,193.2                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "273.6,96 150.5,96 212,202.6                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "282.3,91.3 141.8,91.3 212,213.1                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "291.1,86.5 133,86.5 212,223.5                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "299.8,80.8 124.3,80.8 212,232.9                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "308.5,76.1 115.5,76.1 212,243.3                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "317.3,71.3 106.8,71.3 212,253.7                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "326,66.6 98,66.6 212,264.1                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "334.8,60.9 89.3,60.9 212,273.6                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "343.5,56.1 80.5,56.1 212,284                     "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "352.3,51.4 71.8,51.4 212,294.4                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "361,45.7 63.1,45.7 212,303.9                     "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "369.8,40.9 54.3,40.9 212,314.3                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "378.5,36.2 45.6,36.2 212,324.7                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "387.3,30.5 36.8,30.5 212,334.1                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "396,25.7 28.1,25.7 212,344.5                     "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "212,354.9 404.8,21 19.3,21                   "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape_4_",
    transform: "translate(403.545673, 348.650000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "229.8,121.7 194.2,121.7 212,152.5                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "238.6,116.9 185.5,116.9 212,162.9                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "247.3,111.2 176.7,111.2 212,172.4                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "256.1,106.5 168,106.5 212,182.8                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "264.8,101.7 159.2,101.7 212,193.2                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "273.6,96 150.5,96 212,202.6                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "282.3,91.3 141.7,91.3 212,213.1                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "291,86.5 133,86.5 212,223.5                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "299.8,80.8 124.3,80.8 212,232.9                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "308.5,76.1 115.5,76.1 212,243.3                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "317.3,71.3 106.8,71.3 212,253.7                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "326,66.6 98,66.6 212,264.1                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "334.8,60.9 89.3,60.9 212,273.6                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "343.5,56.1 80.5,56.1 212,284                     "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "352.3,51.4 71.8,51.4 212,294.4                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "361,45.7 63,45.7 212,303.9                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "369.7,40.9 54.3,40.9 212,314.3                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "378.5,36.2 45.5,36.2 212,324.7                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "387.2,30.5 36.8,30.5 212,334.1                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "396,25.7 28.1,25.7 212,344.5                     "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "212,354.9 404.7,21 19.3,21                   "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape_5_",
    transform: "translate(202.247596, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "229.4,122.6 193.8,122.6 211.6,153.5                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "238.1,116.9 185,116.9 211.6,162.9                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "246.9,112.2 176.3,112.2 211.6,173.3                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "255.6,107.4 167.5,107.4 211.6,183.7                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "264.4,101.7 158.8,101.7 211.6,193.2                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "273.1,97 150.1,97 211.6,203.6                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "281.9,92.2 141.3,92.2 211.6,214                  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "290.6,86.5 132.6,86.5 211.6,223.5                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "299.4,81.8 123.9,81.8 211.6,233.9                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "308.1,77 115.1,77 211.6,244.3                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "316.9,71.3 106.4,71.3 211.6,253.7                    "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "325.7,66.6 97.7,66.6 211.7,264.1                     "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "334.4,60.9 88.9,60.9 211.7,273.6                     "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "343.2,56.1 80.2,56.1 211.7,284                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "351.9,51.4 71.4,51.4 211.7,294.4                     "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "360.7,45.7 62.7,45.7 211.7,303.9                     "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "369.4,40.9 54,40.9 211.7,314.3                   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "378.2,36.2 45.2,36.2 211.7,324.7                     "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "386.9,30.5 36.5,30.5 211.7,334.1                     "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "395.7,25.7 27.7,25.7 211.7,344.5                     "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#006D5C",
    points: "211.7,354.9 404.4,21 19,21                   "
  }))))))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-rbz-1",
    maskUnits: "userSpaceOnUse",
    x: -202.6,
    y: -123.5,
    width: 790.7,
    height: 684.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-2_2_",
    fill: "#FFFFFF",
    d: "M192.1,59.5L52.3,140.2v161.4l139.8,80.7l139.8-80.7V140.2L192.1,59.5z M192.1,39.8                    l156.8,90.5v181l-156.8,90.5L35.3,311.4v-181L192.1,39.8z"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-rbz-2",
    maskUnits: "userSpaceOnUse",
    x: -238.1,
    y: -163,
    width: 790.7,
    height: 684.1
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "mask-stoke",
    fill: "none",
    stroke: "#A58D28",
    strokeWidth: 20,
    points: "192.5,49.5 340.3,135 339.5,306.3 192.3,392.3 44,306.5 43.8,136     "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "styleguide"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elements",
    transform: "translate(-884.000000, -80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1_",
    transform: "translate(884.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "without-distinction",
    id: "Rectangle",
    fill: "none",
    stroke: "#006D5C",
    strokeWidth: 3,
    d: "M117,331v168l75-40.3l75,40.3V331H117z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "without-distinction",
    id: "Group-3",
    transform: "translate(190.000000, 407.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    fill: "none",
    stroke: "#006D5C",
    strokeLinecap: "square",
    d: "M2,52V24.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1_",
    fill: "none",
    stroke: "#006D5C",
    strokeLinecap: "square",
    d: "M13,58V28.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2_",
    fill: "none",
    stroke: "#006D5C",
    strokeLinecap: "square",
    d: "M25.5,62.7v-40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3_",
    fill: "none",
    stroke: "#006D5C",
    strokeLinecap: "square",
    d: "M37,71V16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4_",
    fill: "none",
    stroke: "#006D5C",
    strokeLinecap: "square",
    d: "M50,78V7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5_",
    fill: "none",
    stroke: "#006D5C",
    strokeLinecap: "square",
    d: "M63,85V1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "without-distinction",
    id: "Group-2",
    transform: "translate(156.500000, 447.500000) scale(-1, 1) translate(-156.500000, -447.500000) translate(130.000000, 405.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line-Copy",
    fill: "none",
    stroke: "#006D5C",
    strokeLinecap: "square",
    d: "M1,58V28.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-Copy-2",
    fill: "none",
    stroke: "#006D5C",
    strokeLinecap: "square",
    d: "M12.5,62.7v-40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-Copy-3",
    fill: "none",
    stroke: "#006D5C",
    strokeLinecap: "square",
    d: "M25,71V16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-Copy-4",
    fill: "none",
    stroke: "#006D5C",
    strokeLinecap: "square",
    d: "M37,78V7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-Copy-5",
    fill: "none",
    stroke: "#006D5C",
    strokeLinecap: "square",
    d: "M51,85V1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "without-distinction",
    id: "Polygon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    fill: "#FFFFFF",
    points: "192.1,1.5 383,111.7 383,332.1 192.1,442.3 1.2,332.1 1.2,111.7                        "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#006D5C",
    d: "M192.1,2L1.7,112v219.9l190.4,109.9l190.4-109.9V112L192.1,2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1_",
    fill: "none",
    stroke: "#006D5C",
    d: "M192.1,100.5L87,161.2v121.4l105.1,60.7l105.1-60.7V161.2L192.1,100.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2_",
    fill: "none",
    stroke: "#006D5C",
    strokeWidth: 3,
    d: "M192.1,79.3L68.6,150.6v142.6l123.5,71.3l123.5-71.3                                V150.6L192.1,79.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(18.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-2_1_",
    fill: "#FFFFFF",
    d: "M174.1,39.5L34.3,120.2v161.4l139.8,80.7l139.8-80.7V120.2L174.1,39.5z M174.1,19.9                                        l156.8,90.5v181l-156.8,90.5L17.3,291.4v-181L174.1,19.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "without-distinction",
    id: "Polygon_3_",
    fill: "none",
    stroke: "#006D5C",
    strokeWidth: 3,
    d: "M174.1,3.2L2.9,102v197.7l171.3,98.9l171.3-98.9V102                                    L174.1,3.2z"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-rbz-2)"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#bg-grope"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultIcon);
export default __webpack_public_path__ + "static/media/result-icon.a67fb5dabde9eb8d4f4cef5b52f9a365.svg";
export { ForwardRef as ReactComponent };